import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import FireDeparmentSidebar from "../firedepartment/FireDepartmentSidebar";
import NagarrachanaSidebar from "../nagarrachana/NagarrachanaSidebar";
// import { Outlet } from "react-router-dom";

const NagarrachanaContainer = () => {
  document.title = "Nagar Rachana Department";
  const nagaruser = useSelector((store) => store.nagaruser);

  return (
    <>
      <div className="row ">
        <NagarrachanaSidebar role="Nagar Department" />
        <div className="container">
          {nagaruser ? <Outlet /> : <Navigate to="/nagar-department" />}
          {/* <Outlet /> */}
        </div>
      </div>
      {/* <div className="row ">
          <div className="col-md-3">
            <Sidebar role="Super Admin" />
          </div>
          <div className="col-md-9">
            <div className="container">
              {superadmin ? <Outlet /> : <Navigate to="/superadmin" />}
            </div>
          </div>
        </div> */}
    </>
  );
};

export default NagarrachanaContainer;
